module.exports = __webpack_public_path__ + "img/bcpt.af11612c.svg";